import React from "react";

// Premium browser/laptop mockup built with pure CSS — no external dependencies.
export function BrowserMockup({ className = "" }) {
  return (
    <div
      className={`relative rounded-2xl border border-white/10 bg-[#0B0F19] shadow-[0_30px_80px_-20px_rgba(59,130,246,0.45)] overflow-hidden ${className}`}
      data-testid="browser-mockup"
    >
      {/* Top bar */}
      <div className="flex items-center gap-1.5 px-4 py-3 bg-slate-900/80 border-b border-white/5">
        <span className="h-3 w-3 rounded-full bg-red-400/80" />
        <span className="h-3 w-3 rounded-full bg-yellow-400/80" />
        <span className="h-3 w-3 rounded-full bg-green-400/80" />
        <div className="ml-3 flex-1 h-6 rounded-md bg-slate-800/80 border border-white/5 px-3 flex items-center text-[10px] text-slate-400">
          instantsiterevival.com
        </div>
      </div>

      {/* Site content */}
      <div className="bg-white">
        <div className="px-5 py-4 flex items-center justify-between border-b border-slate-100">
          <div className="flex items-center gap-2">
            <div className="h-6 w-6 rounded-md bg-gradient-to-br from-blue-500 to-indigo-600" />
            <div className="h-3 w-24 rounded bg-slate-900" />
          </div>
          <div className="hidden sm:flex items-center gap-3">
            <div className="h-2.5 w-10 rounded bg-slate-200" />
            <div className="h-2.5 w-12 rounded bg-slate-200" />
            <div className="h-2.5 w-10 rounded bg-slate-200" />
            <div className="h-7 w-20 rounded-full bg-yellow-400" />
          </div>
        </div>
        <div className="px-5 sm:px-8 py-6 sm:py-8 grid grid-cols-1 sm:grid-cols-5 gap-5 items-center">
          <div className="sm:col-span-3 space-y-3">
            <div className="h-3 w-24 rounded-full bg-blue-100" />
            <div className="h-5 sm:h-6 w-11/12 rounded bg-slate-900" />
            <div className="h-5 sm:h-6 w-9/12 rounded bg-slate-900" />
            <div className="h-2.5 w-full rounded bg-slate-200" />
            <div className="h-2.5 w-10/12 rounded bg-slate-200" />
            <div className="flex gap-2 pt-2">
              <div className="h-8 w-28 rounded-full bg-blue-600" />
              <div className="h-8 w-24 rounded-full bg-slate-100 border border-slate-200" />
            </div>
          </div>
          <div className="sm:col-span-2">
            <div className="aspect-[4/3] rounded-xl bg-gradient-to-br from-blue-500 via-indigo-500 to-purple-600 shadow-lg" />
          </div>
        </div>
        <div className="px-5 sm:px-8 pb-6 grid grid-cols-3 gap-3">
          {[0, 1, 2].map((i) => (
            <div key={i} className="rounded-xl border border-slate-100 p-3 space-y-2 bg-white">
              <div className="h-7 w-7 rounded-lg bg-blue-100" />
              <div className="h-2.5 w-full rounded bg-slate-200" />
              <div className="h-2.5 w-8/12 rounded bg-slate-200" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function PhoneMockup({ className = "" }) {
  return (
    <div
      className={`relative w-[200px] sm:w-[230px] aspect-[9/19] rounded-[2.4rem] bg-[#0B0F19] border border-white/10 p-2.5 shadow-[0_30px_80px_-20px_rgba(250,204,21,0.45)] ${className}`}
      data-testid="phone-mockup"
    >
      <div className="absolute top-3 left-1/2 -translate-x-1/2 h-5 w-24 rounded-full bg-black z-10" />
      <div className="h-full w-full rounded-[2rem] bg-white overflow-hidden">
        <div className="h-12 bg-[#0B0F19] flex items-center justify-between px-4 text-[9px] text-slate-300">
          <span>9:41</span>
          <span>● ● ●</span>
        </div>
        <div className="px-4 py-4 space-y-2">
          <div className="h-2.5 w-16 rounded-full bg-yellow-400" />
          <div className="h-3 w-11/12 rounded bg-slate-900" />
          <div className="h-3 w-9/12 rounded bg-slate-900" />
          <div className="h-2 w-full rounded bg-slate-200" />
          <div className="h-2 w-10/12 rounded bg-slate-200" />
          <div className="h-24 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 mt-2" />
          <div className="h-8 w-full rounded-full bg-yellow-400 mt-2" />
          <div className="h-8 w-full rounded-full bg-slate-100 border border-slate-200" />
          <div className="grid grid-cols-2 gap-2 mt-2">
            <div className="h-14 rounded-lg bg-slate-100" />
            <div className="h-14 rounded-lg bg-slate-100" />
          </div>
        </div>
      </div>
    </div>
  );
}

export function OldBrowserMockup({ className = "" }) {
  return (
    <div
      className={`relative rounded-xl border border-slate-300 bg-[#f4f1e8] shadow-lg overflow-hidden ${className}`}
      data-testid="old-browser-mockup"
    >
      <div className="flex items-center gap-1.5 px-3 py-2 bg-slate-200 border-b border-slate-300">
        <span className="h-3 w-3 rounded-full bg-slate-400" />
        <span className="h-3 w-3 rounded-full bg-slate-400" />
        <span className="h-3 w-3 rounded-full bg-slate-400" />
      </div>
      <div className="px-4 py-4 bg-[#fffbf0]">
        <div className="border-2 border-slate-400 p-3 mb-3 bg-[#fef9e7]">
          <div className="font-mono text-[11px] text-slate-700 font-bold uppercase">★ Welcome to our website! ★</div>
          <div className="font-mono text-[9px] text-slate-600 mt-1">Best viewed in Internet Explorer 6</div>
        </div>
        <div className="grid grid-cols-3 gap-2 mb-3">
          <div className="h-3 bg-blue-700" />
          <div className="h-3 bg-blue-700" />
          <div className="h-3 bg-blue-700" />
        </div>
        <div className="space-y-1.5">
          <div className="h-2 w-11/12 bg-slate-300" />
          <div className="h-2 w-9/12 bg-slate-300" />
          <div className="h-2 w-10/12 bg-slate-300" />
          <div className="h-2 w-8/12 bg-slate-300" />
        </div>
        <div className="mt-3 inline-block px-2 py-0.5 bg-yellow-300 border border-yellow-600 font-mono text-[9px] text-slate-800">
          Last updated: 2009
        </div>
      </div>
    </div>
  );
}
